import { PriceFeedData } from 'src/common/api-clients/swarm/types'
import { useQuery } from '@tanstack/react-query'
import { getPriceFeeds } from '../../api-clients/swarm'
import useActiveOrDefaultChain from '../../hooks/web3/useActiveOrDefaultChain'

export type UsePriceFeedsData = Map<string, PriceFeedData>

export const usePriceFeed = (contractAddress: string | undefined) => {
  const chain = useActiveOrDefaultChain()

  const { data: priceFeeds, ...rest } = useQuery({
    queryFn: async () => {
      const data = await getPriceFeeds(chain.id, [contractAddress!])
      return data
    },
    queryKey: ['price-feed', chain.id, contractAddress],
    enabled: Boolean(contractAddress),
  })

  return {
    priceFeed: priceFeeds?.[0],
    ...rest,
  }
}
